var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticStyle: {
        "border-bottom-left-radius": "20px",
        "border-bottom-right-radius": "20px",
        cursor: "pointer"
      },
      attrs: { "body-style": { padding: "0px" }, shadow: "always" }
    },
    [
      _c(
        "div",
        {
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.goPropertyDetails(
                _vm.property.housePropertyPOJO.propertyId
              )
            }
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticClass: "img-container", attrs: { span: 24 } },
                [
                  _vm.property.housePropertyPOJO.imgLst == undefined ||
                  _vm.property.housePropertyPOJO.imgLst[0] == null ||
                  _vm.property.housePropertyPOJO.imgLst[0] == ""
                    ? _c("el-image", {
                        staticClass: "image",
                        attrs: {
                          loading: "lazy",
                          src: "../../../static/img/coming-soon.jpg"
                        }
                      })
                    : _c("el-image", {
                        staticStyle: { height: "100%", width: "100%" },
                        attrs: {
                          src: _vm.property.housePropertyPOJO.imgLst[0],
                          fit: "cover"
                        }
                      })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  style: {
                    backgroundColor:
                      _vm.property.housePropertyPOJO.companyColour || "#003333",
                    padding: "5px 10px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c("el-image", {
                    staticClass: "image",
                    staticStyle: { "max-height": "40px", "max-width": "120px" },
                    attrs: {
                      src: _vm.property.housePropertyPOJO.companyLogoUrl
                    }
                  }),
                  _vm._v(" "),
                  _c("el-avatar", {
                    staticStyle: {
                      position: "absolute",
                      top: "25px",
                      right: "25px",
                      border: "2px solid #003333"
                    },
                    attrs: {
                      size: 50,
                      src: _vm.property.housePropertyPOJO.agentImageUrl1
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { padding: "10px 10px 5px 10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("span", { staticClass: "price-range-lbl" }, [
                  _vm._v(_vm._s(_vm.formattedPriceRange))
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { padding: "5px 10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "address-lbl omit" },
                  [
                    _vm.property.housePropertyPOJO.address &&
                    _vm.property.housePropertyPOJO.suburb
                      ? [
                          _vm._v(
                            _vm._s(_vm.property.housePropertyPOJO.address) +
                              ",\n                          " +
                              _vm._s(_vm.property.housePropertyPOJO.suburb)
                          )
                        ]
                      : _vm.property.housePropertyPOJO.address
                      ? [_vm._v(_vm._s(_vm.property.housePropertyPOJO.address))]
                      : _vm.property.housePropertyPOJO.suburb
                      ? [_vm._v(_vm._s(_vm.property.housePropertyPOJO.suburb))]
                      : [_vm._v("TBA")]
                  ],
                  2
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { staticStyle: { padding: "5px 10px" } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c(
                  "span",
                  { staticClass: "state-lbl" },
                  [
                    _vm.property.housePropertyPOJO.state &&
                    _vm.property.housePropertyPOJO.postcode
                      ? [
                          _vm._v(
                            _vm._s(_vm.property.housePropertyPOJO.state) +
                              "\n                          " +
                              _vm._s(_vm.property.housePropertyPOJO.postcode)
                          )
                        ]
                      : _vm.property.housePropertyPOJO.state
                      ? [_vm._v(_vm._s(_vm.property.housePropertyPOJO.state))]
                      : _vm.property.housePropertyPOJO.postcode
                      ? [
                          _vm._v(
                            _vm._s(_vm.property.housePropertyPOJO.postcode)
                          )
                        ]
                      : [_vm._v("TBA")]
                  ],
                  2
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    padding: "0 20px"
                  },
                  attrs: { span: 24 }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "del-btn",
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.removeFavourite(
                            _vm.property.housePropertyPOJO.propertyId
                          )
                        }
                      }
                    },
                    [_vm._v("Remove")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76208bc5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76208bc5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myFavourites/favouritePropertyCard.vue
// module id = null
// module chunks = 